import * as STD from '@emersya/mpa-std-lib';

import CM                                  from '@emersya/mpa-components-manager-lib';
import ViewerComponent, { NS as ViewerNS } from '../../../viewer/Viewer/Viewer';

export interface IStandingTVComponentConfiguration extends CM.Component.IConfiguration {
	// To not duplicate many property of the app configuration, and because this component is unique, retrieve conf directly from app and lets this interface be empty.
};

export class StandingTVComponent extends CM.Component<
	StandingTVComponent,
	IStandingTVComponentConfiguration
>
{
	static override initialize() {
		super.initialize();
	};

	readonly plannerCategory! : ViewerComponent.ProductCategory;
	viewerNode : ViewerComponent.ProductInstance | null = null;

	getWDH() {
		const p = app.currentProduct;
		if (!p) {
			this.component_throwUserError('');
		}
		const dpart = p.getPart([ 'dimensions' ]);
		return {
			width :  Number.parseFloat(dpart.getPart([ 'width' ])?.reference?.value || <string> <any> 1),
			depth :  Number.parseFloat(dpart.getPart([ 'depth' ])?.reference?.value || <string> <any> 1),
			height : Number.parseFloat(dpart.getPart([ 'height' ])?.reference?.value || <string> <any> 1)
		};
	};

	getWallThickness() {
		// TODO : DEHARDCODE
		return 0.05;
	}

	private computeMatrix() {
		const wdh = this.getWDH();
		const x = wdh.width;
		const y = wdh.height;
		const z = wdh.depth;
		void y;
		const product = app.currentProduct;
		if (!product) {
			throw STD.errors.user('No current product available!');
		}
		const currentCounter = app.component_configuration.productsComponents.find(x => x.type === 'counter');
		if (!currentCounter) {
			throw STD.errors.user('No current partitions head found');
		}
		const boundingBox = currentCounter.boundingBox;
		if (!boundingBox) {
			throw STD.errors.user('Missing bounding box for head partition ' + currentCounter.SKU);
		}
		const layoutPart = product.getPart([ 'layout' ]);
		if (!layoutPart) {
			throw STD.errors.user('No part layout available');
		}
		const layoutCurrentOption = layoutPart.currentOption;
		if (!layoutCurrentOption) {
			throw STD.errors.user('No current option in layout part');
		}
		const layoutId = layoutCurrentOption.id;
		const storage3x1CornerLeft = app.component_configuration.productsComponents.find(x => x.type ===
			'storage' &&
			x.SKU ===
			'storage3x1CornerLeft');
		if (!storage3x1CornerLeft) {
			throw STD.errors.user('No storage 3x1 corner left found');
		}
		const boundingBox3x1CornerLeft = storage3x1CornerLeft.boundingBox;
		if (!boundingBox3x1CornerLeft) {
			throw STD.errors.user('Missing bounding box for storage ');
		}
		const storage3x1CornerRight = app.component_configuration.productsComponents.find(x => x.type ===
			'storage' &&
			x.SKU ===
			'storage3x1CornerRight');
		if (!storage3x1CornerRight) {
			throw STD.errors.user('No storage 3x1 Corner Right found');
		}
		const boundingBox3x1CornerRight = storage3x1CornerRight.boundingBox;
		if (!boundingBox3x1CornerRight) {
			throw STD.errors.user('Missing bounding box for storage ');
		}
		const archLeft = app.component_configuration.productsComponents.find(x => x.type ===
			'arch' &&
			x.SKU ===
			'arch-prestige-left');
		if (!archLeft) {
			throw STD.errors.user('No arch left found');
		}
		const boundingBoxArchLeft = archLeft.boundingBox;
		if (!boundingBoxArchLeft) {
			throw STD.errors.user('Missing bounding box for storage ');
		}
		const archRight = app.component_configuration.productsComponents.find(x => x.type ===
			'arch' &&
			x.SKU ===
			'arch-prestige-right');
		if (!archRight) {
			throw STD.errors.user('No arch right found');
		}
		const boundingBoxArchRight = archRight.boundingBox;
		if (!boundingBoxArchRight) {
			throw STD.errors.user('Missing bounding box for storage ');
		}
		const archSpecial = app.component_configuration.productsComponents.find(x => x.type ===
			'arch' &&
			x.SKU ===
			'arch-prestige-special');
		if (!archSpecial) {
			throw STD.errors.user('No arch special found');
		}
		const boundingBoxArchSpecial = archSpecial.boundingBox;
		if (!boundingBoxArchSpecial) {
			throw STD.errors.user('Missing bounding box for storage ');
		}
		if (layoutId === 'shape-no-wall') {
			return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0));
		} else if (layoutId === 'shape-back-left') {
			if(x < 4){
				return (ViewerNS.Component.mtx(
					[ x / 2 - (x - boundingBox3x1CornerRight.width) / 2, 0, -z / 2 ],
					[ 1, 1, 1 ],
					0
				));	
			}
			return (ViewerNS.Component.mtx(
				[ -x / 2 + boundingBox3x1CornerRight.width + boundingBoxArchLeft.width / 2, 0, -z / 2 ],
				[ 1, 1, 1 ],
				0
			));
		} else if (layoutId === 'shape-back') {
			if(x < 4){
				return (ViewerNS.Component.mtx(
					[ x / 2 - (x - boundingBox3x1CornerRight.width) / 2, 0, -z / 2 ],
					[ 1, 1, 1 ],
					0
				));	
			}
			return (ViewerNS.Component.mtx(
				[ -x / 2 + boundingBox3x1CornerRight.width + boundingBoxArchLeft.width / 2, 0, -z / 2 ],
				[ 1, 1, 1 ],
				0
			));
		} else if (layoutId === 'shape-back-right') {
			if(x < 4 ){
				return (ViewerNS.Component.mtx(
					[ -x / 2 + (x - boundingBox3x1CornerLeft.width)/2, 0, -z / 2 ],
					[ 1, 1, 1 ],
					0
				));
			}
			return (ViewerNS.Component.mtx(
				[ x / 2 - boundingBox3x1CornerLeft.width - boundingBoxArchRight.width / 2, 0, -z / 2 ],
				[ 1, 1, 1 ],
				0
			));
		} else if (layoutId === 'shape-left-back-right') {
			if(x < 4 ){
				return (ViewerNS.Component.mtx(
					[ 0, 0, -z / 2 ],
					[ 1, 1, 1 ],
					0
				));
			}
			return (ViewerNS.Component.mtx([ -x / 2 + boundingBoxArchSpecial.width / 2, 0, -z / 2 ], [ 1, 1, 1 ], 0));
		} else {
			throw STD.errors.user('Unknown layoutId in counter');
		}
	}

	async insert() {
		// insert nodes
		const product = app.currentProduct;
		if (this.viewerNode || !product || !app.viewer.planner) {
			this.component_throwUserError('');
		}
		if (product.id === 'confort' || product.id === 'business' || product.id === 'siae') {
			return;
		}
		const category = app.viewer.categories.find(x => x.name === 'tv');
		if (!category) {
			this.component_throwLibraryError('');
		}
		if (app.isReloading) {
			const instances = Array.from(app.viewer.safe.value.productInstances);
			const node = instances.find(x => x.product.category === category);
			if (!node) {
				return;
			}
			this.viewerNode = node;
			this.viewerNode.setName('tv');
			return;
		}
		const tvProductSchema = this.plannerCategory.products.find(x => x.SKU === '@tv');
		if (!tvProductSchema) {
			this.component_throwLibraryError('');
		}
		this.viewerNode = await tvProductSchema.instantiate({
			rootLocalId  : app.viewer.globalLocalId,
			appendType : 'insert',
			basketPart : [],
			basketUseDynamicTitleBinding : true,
			metadata : {
				id : this.id
			}
		});
		this.viewerNode.setName('tv');
	};

	async update() {
		// update nodes matrices
		if (!this.viewerNode) {
			return;
		}
		const product = app.currentProduct;
		if (!product) {
			throw STD.errors.user('No current product available!');
		}
		if (product.id === 'confort' || product.id === 'business' || product.id === 'siae') {
			return;
		}
		const layoutPart = product.getPart([ 'layout' ]);
		if (!layoutPart) {
			throw STD.errors.user('No current product available!');
		}
		const layoutCurrentOption = layoutPart.currentOption;
		if (!layoutCurrentOption) {
			return;
		}
		await app.viewer.batch([
			[
				'setProductNodesInstancesMatrices', [
				{
					localId : this.viewerNode.localId,
					matrix :  this.computeMatrix()
				}
			]
			]
		]);
	};

	async remove() {
		if (!this.viewerNode) {
			return;
		}
		await this.viewerNode.delete();
		this.viewerNode = null;
	};

	override async component_initialize() {
		await super.component_initialize();
	};

	override async component_start(startEvent : STD.events.Event<any, CM.Component<any, any>>) {
		await super.component_start(startEvent);
		if (!app.viewer.planner) {
			this.component_throwUserError('');
		}
		const tvComponent = app.component_configuration.productsComponents.find(x => x.type === 'tv');

		const categoryDescriptor : ViewerComponent.ProductCategory.IDescriptor & {
			products : NonNullable<ViewerComponent.ProductCategory.IDescriptor['products']>;
		} = {
			name :        'tv',
			menuActions : {
				edit :      false,
				delete :    false,
				rotate :    false,
				duplicate : false
			},
			products :    []
		};
		if (app.component_configuration.products.find(x => x.SKU === 'prestige')) {
			if (!tvComponent) {
				throw STD.errors.user('Missing tv component');
			}
			categoryDescriptor.products.push({
				SKU :   '@tv',
				nodes : [
					{
						SKU :                         <string> tvComponent.viewerComponentSKU,
						projectCode :                 <string> tvComponent.viewerProjectCode,
						localId :                     'global',
						parentLocalId :               'root',
						snappable :                   false,
						fixedPositionSetIds :         null,
						draggable :                   false,
						doNotListAsProductComponent : true,
						matrix :                      app.viewer.mtx(
							[ 0, 0, 0 ],
							[ 0, 0, 0 ],
							0
						)
					}
				]
			});
		}
		(<STD.object.SetWritable<this, 'plannerCategory'>> this).plannerCategory = app.viewer.createCategory(categoryDescriptor);
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IStandingTVComponentConfiguration
	)
	{
		super(descriptor, configuration);
	};
};
export namespace NS {
	export const Component = StandingTVComponent;
	export type Component = StandingTVComponent;
	export type Configuration = IStandingTVComponentConfiguration;
}
CM.declare({
	id :   'standing-tv',
	type : StandingTVComponent
});
